import { Filter, SelectedFilterOption } from 'src/types';

const getFilterOptionValue = (filterOptionValue?: SelectedFilterOption['filterOptionValue']) => {
  if (typeof filterOptionValue === 'string' || typeof filterOptionValue === 'number') {
    return 1;
  } else if (typeof filterOptionValue === 'object' && filterOptionValue.length) {
    return filterOptionValue.length;
  }

  return 0;
};

export const getFilterOptionsForFilter = (
  filter: Filter,
  selectedFilterOptions: SelectedFilterOption[],
) => selectedFilterOptions.filter((sf) => sf.filterUid === filter.uid);

export const getFilterOptionCount = (option: SelectedFilterOption) =>
  option.selectedByDefault ? 0 : getFilterOptionValue(option.filterOptionValue);

export const getFilterCount = (option: SelectedFilterOption) => (option.selectedByDefault ? 0 : 1);

export const getTitleFromFilterOptionUid = (filterOptionUid: string) => {
  const filterOptionTitle = filterOptionUid!.match(/filter\[(.*)\]/);
  return filterOptionTitle?.[1] ? filterOptionTitle[1].replace(/_/g, ' ') : filterOptionUid;
};
